import { MessageSquare, Globe, Instagram, User } from 'lucide-react';

const ARS_FORMATTER = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  maximumFractionDigits: 0,
});

export function formatBudget(budget) {
  if (!budget) return null;
  return ARS_FORMATTER.format(budget);
}

export function getDisplayName(customer) {
  if (!customer) return 'Sin nombre';
  if (customer.firstName || customer.lastName) {
    return `${customer.firstName || ''} ${customer.lastName || ''}`.trim();
  }
  return customer.fullName || 'Sin nombre';
}

export const SOURCE_CONFIG = {
  whatsapp: {
    label: 'WhatsApp',
    icon: MessageSquare,
    badgeColor: 'bg-green-100 text-green-700',
    textColor: 'text-green-600',
  },
  web: {
    label: 'Web',
    icon: Globe,
    badgeColor: 'bg-blue-100 text-blue-700',
    textColor: 'text-blue-600',
  },
  instagram: {
    label: 'Instagram',
    icon: Instagram,
    badgeColor: 'bg-pink-100 text-pink-700',
    textColor: 'text-pink-600',
  },
  manual: {
    label: 'Manual',
    icon: User,
    badgeColor: 'bg-slate-100 text-slate-600',
    textColor: 'text-slate-500',
  },
};

export const KANBAN_STATUSES = [
  { value: 'new', label: 'Nuevo' },
  { value: 'in_conversation', label: 'En conversación' },
  { value: 'interested', label: 'Interesado' },
  { value: 'no_response', label: 'No responde' },
  { value: 'closed_won', label: 'Cerrado/Ganado' },
  { value: 'closed_lost', label: 'Cerrado/Perdido' },
];

export const INTENT_CONFIG = {
  browsing: { label: 'Explorando', className: 'bg-slate-100 text-slate-600' },
  comparing: { label: 'Comparando', className: 'bg-amber-100 text-amber-700' },
  ready_to_buy: { label: 'Listo para comprar', className: 'bg-emerald-100 text-emerald-700' },
};

export const STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-700',
  in_conversation: 'bg-amber-100 text-amber-700',
  interested: 'bg-emerald-100 text-emerald-700',
  no_response: 'bg-slate-100 text-slate-600',
  closed_won: 'bg-slate-800 text-white',
  closed_lost: 'bg-red-100 text-red-700',
  contacted: 'bg-blue-100 text-blue-700',
  qualified: 'bg-purple-100 text-purple-700',
  closed: 'bg-slate-700 text-white',
};
